const Badge4 = () => (
  <svg className="badge-4" fill="none" height="151" viewBox="0 0 167 151" width="167" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_792_417)">
      <g opacity="0.45" style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M76.98 47.9L71.7 65.88L55.53 55.54L27.51 37.63L4.79 23.09C2.58 21.68 1.28 19.19 1.39 16.57L1.62 10.87V10.8L2.07 0L50.71 31.1L53.36 32.8L62.87 38.88L76.99 47.9H76.98Z"
          fill="url(#paint0_linear_792_417)"
        />
        <path
          d="M70.27 70.79L65.58 86.77L46.12 74.33L17.88 56.28L3.79 47.27C1.58 45.86 0.279996 43.37 0.389996 40.75V40.65L0.739996 32.18L0.979996 26.49L24.59 41.58L53.42 60.01L70.27 70.79Z"
          fill="url(#paint1_linear_792_417)"
        />
        <path
          d="M64.14 91.68L59.45 107.66L35.02 92.04L4.99 72.84C3.33 71.78 2.15 70.1 1.73 68.17C1.03 64.91 0.539999 61.61 0.259999 58.26C0.0599989 55.76 -0.0300011 53.24 -1.06636e-06 50.69L16.39 61.17L43.69 78.62L64.13 91.69L64.14 91.68Z"
          fill="url(#paint2_linear_792_417)"
        />
        <path
          d="M58.01 112.58L52.24 132.25L28.07 111.56C25 109.02 22.15 106.26 19.56 103.32C14.56 97.69 10.43 91.39 7.31 84.65C7.28 84.61 7.26 84.57 7.25 84.54L7.2 84.42C6.87 83.74 6.57 83.06 6.28 82.37C6.28 82.37 6.28 82.36 6.28 82.35C5.73 81.09 5.22 79.81 4.75 78.52L5.58 79.05L31.95 95.91L58.03 112.59L58.01 112.58Z"
          fill="url(#paint3_linear_792_417)"
        />
        <path
          d="M76.98 47.9C76.98 47.9 70.59 45.33 61.65 41.74C58.43 40.44 54.88 39.01 51.18 37.52C32.69 30.05 10.49 21.06 7.29 19.62C2.02 17.24 1.65 11.57 1.62 10.86C1.62 10.81 1.62 10.79 1.62 10.79L2.07 0L50.71 31.1L53.36 32.8L62.87 38.88L76.99 47.9H76.98Z"
          fill="#1A2819"
          opacity="0.75"
        />
        <path
          d="M70.27 70.79L52 62.91L20.51 49.32L0.399994 40.65L0.739994 32.18L0.979994 26.49L24.59 41.58L53.42 60.01L70.27 70.79Z"
          fill="#1A2819"
        />
        <path d="M64.14 91.68L42.64 80.44L6.76 61.67L0.26 58.27L0 50.69L16.4 61.17L43.7 78.62L64.14 91.68Z" fill="#1A2819" />
        <path
          d="M58.01 112.58L30.53 97.44L7.30001 84.64H7.28001L7.24001 84.53L7.19001 84.41L6.17001 81.96C6.17001 81.96 6.17001 81.95 6.17001 81.94L4.74001 78.51L5.57001 79.04L31.94 95.9L58.02 112.58H58.01Z"
          fill="#1A2819"
        />
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M31.93 95.9C31.46 96.44 30.99 96.95 30.53 97.44C26.65 101.5 22.89 103.84 19.56 103.31C14.56 97.68 10.43 91.38 7.31 84.64H7.29L7.25 84.53L7.2 84.41C6.87 83.73 6.57 83.05 6.28 82.36C6.28 82.36 6.28 82.35 6.28 82.34C6.24 82.21 6.21 82.08 6.19 81.96C6.19 81.96 6.19 81.95 6.19 81.94C5.94 80.95 5.74 79.98 5.59 79.04L31.96 95.9H31.93Z"
            fill="black"
          />
        </g>
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M43.7 78.62C43.36 79.24 43 79.85 42.64 80.45C40.15 84.67 37.59 88.64 35.02 92.05L4.99 72.85C4.92 66.98 6.24 62.96 6.76 61.67C6.87 61.36 6.94 61.21 6.94 61.21L15.71 63.78C15.93 62.88 16.17 62.01 16.4 61.17L43.7 78.62Z"
            fill="black"
          />
        </g>
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M53.42 60.01C52.96 60.97 52.5 61.94 52.01 62.91C50.17 66.66 48.19 70.54 46.12 74.33L17.88 56.28C18.74 53.68 19.63 51.38 20.51 49.32C21.89 46.16 23.28 43.62 24.58 41.58L53.41 60.01H53.42Z"
            fill="black"
          />
        </g>
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M62.87 38.87C62.54 39.66 62.14 40.63 61.66 41.73C60.2 45.2 58.08 50.06 55.54 55.53L27.52 37.62C29.99 34.75 31.71 33.9 31.71 33.9L39.77 44.06L51.34 39.66L51.18 37.52L50.7 31.1L53.35 32.8L62.86 38.88L62.87 38.87Z"
            fill="black"
          />
        </g>
        <path
          d="M77.27 47.98L71.99 65.96L91.18 65.99L124.44 66.05L151.42 66.1C154.05 66.1 156.48 64.71 157.8 62.45L160.68 57.52L160.72 57.46L166.18 48.14L108.45 48.03H105.3L94.02 48L77.26 47.97L77.27 47.98Z"
          fill="url(#paint4_linear_792_417)"
        />
        <path
          d="M70.55 70.87L65.86 86.85L88.96 86.89L122.47 86.96L139.19 86.99C141.82 86.99 144.25 85.6 145.57 83.34L145.62 83.25L149.9 75.94L152.78 71.02L124.76 70.97L90.54 70.9L70.54 70.87H70.55Z"
          fill="url(#paint5_linear_792_417)"
        />
        <path
          d="M64.42 91.77L59.73 107.75L88.72 107.8L124.36 107.87C126.33 107.87 128.23 107.09 129.62 105.7C131.97 103.34 134.17 100.82 136.21 98.16C137.74 96.16 139.18 94.09 140.52 91.92L121.06 91.88L88.66 91.81L64.41 91.77H64.42Z"
          fill="url(#paint6_linear_792_417)"
        />
        <path
          d="M58.29 112.66L52.52 132.33L84.04 127.97C88 127.49 91.88 126.71 95.66 125.64C102.91 123.61 109.79 120.54 116.06 116.55C116.11 116.53 116.14 116.51 116.17 116.49L116.27 116.42C116.92 116.03 117.54 115.62 118.16 115.19C118.16 115.19 118.17 115.19 118.17 115.17C119.31 114.41 120.43 113.6 121.52 112.78H120.54L89.25 112.72L58.29 112.67V112.66Z"
          fill="url(#paint7_linear_792_417)"
        />
        <path
          d="M77.27 47.98C77.27 47.98 84.04 49.27 93.5 51.07C96.91 51.71 100.68 52.43 104.59 53.18C124.19 56.89 147.72 61.32 151.19 61.84C156.91 62.69 160.29 58.11 160.69 57.53C160.71 57.49 160.73 57.47 160.73 57.47L166.19 48.15L108.46 48.04H105.31L94.03 48.01L77.27 47.98Z"
          fill="#1A2819"
          opacity="0.75"
        />
        <path
          d="M70.55 70.87L90.17 74.11L124.01 79.69L145.63 83.26L149.91 75.95L152.79 71.03L124.77 70.97L90.55 70.91L70.55 70.87Z"
          fill="#1A2819"
        />
        <path
          d="M64.42 91.77L88.58 93.92L128.92 97.51L136.22 98.15L140.53 91.91L121.07 91.88L88.68 91.81L88.67 91.82L64.42 91.77Z"
          fill="#1A2819"
        />
        <path
          d="M58.29 112.66L89.6 114.77L116.06 116.55H116.08L116.17 116.49L116.27 116.42L118.45 114.91C118.45 114.91 118.46 114.91 118.46 114.89L121.52 112.78H120.54L89.25 112.72L58.29 112.67V112.66Z"
          fill="#1A2819"
        />
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M89.25 112.72C89.36 113.43 89.47 114.12 89.6 114.78C90.67 120.29 92.57 124.29 95.66 125.65C102.91 123.62 109.79 120.55 116.06 116.56H116.08L116.17 116.5L116.27 116.43C116.92 116.04 117.54 115.63 118.16 115.2C118.16 115.2 118.17 115.2 118.17 115.18C118.28 115.1 118.37 115 118.45 114.91C118.45 114.91 118.46 114.91 118.46 114.89C119.21 114.19 119.9 113.48 120.53 112.78L89.24 112.72H89.25Z"
            fill="black"
          />
        </g>
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M88.68 91.8099C88.64 92.5099 88.61 93.2199 88.59 93.9199C88.4 98.8199 88.42 103.54 88.73 107.8L124.37 107.87C127.6 102.97 128.66 98.8699 128.93 97.5099C129 97.1899 129.03 97.0299 129.03 97.0299L120.26 94.4599C120.56 93.5899 120.83 92.7199 121.09 91.8899L88.69 91.8199L88.68 91.8099Z"
            fill="black"
          />
        </g>
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M90.55 70.91C90.41 71.97 90.29 73.03 90.17 74.12C89.69 78.27 89.27 82.61 88.96 86.91L122.47 86.98C123.16 84.33 123.65 81.91 124.01 79.7C124.56 76.3 124.76 73.41 124.77 70.99L90.55 70.92V70.91Z"
            fill="black"
          />
        </g>
        <g opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M94.02 48.01C93.87 48.86 93.68 49.89 93.49 51.07C92.84 54.78 92 60.01 91.18 65.99L124.44 66.05C123.91 62.3 122.92 60.65 122.92 60.65L110.65 64.84L103.29 54.89L104.58 53.17L108.45 48.03H105.3L94.02 48V48.01Z"
            fill="black"
          />
        </g>
        <path
          d="M53.21 128.33C46.72 127.48 41.12 126.07 36.28 124.31C36.09 124.24 35.91 124.18 35.74 124.11C35.35 123.97 34.97 123.82 34.61 123.68C34.25 123.54 33.9 123.4 33.56 123.26C32.93 122.99 32.33 122.72 31.72 122.45C31.35 122.28 30.98 122.11 30.61 121.93C30.23 121.76 29.87 121.57 29.5 121.39C29.14 121.21 28.79 121.03 28.44 120.84C28.11 120.67 27.79 120.5 27.48 120.32C26.77 119.92 26.08 119.52 25.41 119.11C25.11 118.93 24.82 118.74 24.53 118.55C22.68 117.37 21.02 116.15 19.52 114.92C19.07 114.55 18.63 114.18 18.22 113.81C15.9 111.76 14.04 109.72 12.56 107.83C12.41 107.64 12.27 107.46 12.13 107.27C11.9 106.97 11.68 106.67 11.47 106.38C9.27999 103.31 8.14999 100.84 7.69999 99.7401C7.64999 99.6201 7.61999 99.5201 7.57999 99.4401C7.55999 99.3801 7.53999 99.3301 7.51999 99.2801C7.47999 99.1701 7.45999 99.1101 7.45999 99.1101L16.98 96.8901C13.47 92.0801 11.54 85.2301 10.61 78.9001C9.34999 70.3401 9.92999 62.7301 10.93 62.3601C12.66 61.7101 18.38 64.5401 18.38 64.5401C18.56 63.9501 18.75 63.3701 18.96 62.8101C19.23 62.0201 19.52 61.2401 19.83 60.5101C19.96 60.1801 20.08 59.8601 20.23 59.5401C20.41 59.1001 20.6 58.6701 20.79 58.2601C20.9 58.0201 21.01 57.7701 21.12 57.5401C21.28 57.1901 21.45 56.8501 21.61 56.5201C21.84 56.0601 22.06 55.6301 22.3 55.2001C22.51 54.8001 22.73 54.4001 22.94 54.0201C23.09 53.7501 23.25 53.4801 23.41 53.2101C23.56 52.9601 23.7 52.7101 23.85 52.4701C24.25 51.8101 24.66 51.1801 25.06 50.5701C25.3 50.2001 25.55 49.8301 25.81 49.4801C26.3 48.7801 26.81 48.1001 27.31 47.4601C27.79 46.8401 28.26 46.2701 28.73 45.7201C28.76 45.6801 28.8 45.6401 28.84 45.6001C29.06 45.3401 29.29 45.0901 29.5 44.8401C29.74 44.5701 29.97 44.3201 30.21 44.0701C30.6 43.6401 30.98 43.2501 31.36 42.8701C31.68 42.5501 31.99 42.2601 32.29 41.9701C32.6 41.6901 32.88 41.4201 33.16 41.1801C33.23 41.1201 33.29 41.0601 33.35 41.0101C33.53 40.8501 33.71 40.7001 33.87 40.5501C35.41 39.2501 36.38 38.6201 36.38 38.6201C37.28 39.6801 38.24 41.6101 39.16 43.8801C41.78 50.2901 44.16 59.4001 44.16 59.4001C50.64 88.1401 52.49 110.56 53.02 121.32C53.22 125.62 53.22 128.06 53.22 128.31V128.33H53.21Z"
          fill="url(#paint8_linear_792_417)"
        />
        <path
          d="M53.21 128.33C46.72 127.48 41.12 126.07 36.28 124.31C36.09 124.24 35.91 124.18 35.74 124.11C35.35 123.97 34.97 123.82 34.61 123.68C34.25 123.54 33.9 123.4 33.56 123.26C32.93 122.99 32.33 122.72 31.72 122.45C31.35 122.28 30.98 122.11 30.61 121.93C30.23 121.76 29.87 121.57 29.5 121.39C29.14 121.21 28.79 121.03 28.44 120.84C28.11 120.67 27.79 120.5 27.48 120.32C26.77 119.92 26.08 119.52 25.41 119.11C25.11 118.93 24.82 118.74 24.53 118.55C22.68 117.37 21.02 116.15 19.52 114.92C19.07 114.55 18.63 114.18 18.22 113.81C15.9 111.76 14.04 109.72 12.56 107.83C12.41 107.64 12.27 107.46 12.13 107.27C11.9 106.98 11.68 106.68 11.47 106.38C9.27999 103.31 8.14999 100.84 7.69999 99.74C7.65999 99.63 7.61999 99.52 7.57999 99.44C7.55999 99.38 7.53999 99.33 7.51999 99.28C7.47999 99.17 7.45999 99.11 7.45999 99.11L16.98 96.89C13.47 92.08 11.54 85.23 10.61 78.9C12.83 80.2 14.94 81.53 16.93 82.88C30.59 92.15 39.36 102.53 44.86 111.04C45.6 112.19 46.28 113.29 46.9 114.36C46.99 114.49 47.07 114.63 47.15 114.78C51.56 122.43 53.1 127.87 53.21 128.3V128.33Z"
          fill="url(#paint9_linear_792_417)"
        />
        <path
          d="M53.21 128.33C46.72 127.48 41.12 126.07 36.28 124.31C36.09 124.24 35.91 124.18 35.74 124.11C35.35 123.97 34.97 123.82 34.61 123.68C34.25 123.54 33.9 123.4 33.56 123.26C32.93 122.99 32.33 122.72 31.72 122.45C31.35 122.28 30.98 122.11 30.61 121.93C30.23 121.76 29.87 121.57 29.5 121.39C29.14 121.21 28.79 121.03 28.44 120.84C28.11 120.67 27.79 120.5 27.48 120.32C26.77 119.92 26.08 119.52 25.41 119.11C25.11 118.93 24.82 118.74 24.53 118.55C22.68 117.37 21.02 116.15 19.52 114.92C19.07 114.55 18.63 114.18 18.22 113.81C15.9 111.76 14.04 109.72 12.56 107.83C16.85 109.07 20.66 109.96 24 110.58C38.88 113.35 44.73 110.85 44.73 110.85C44.77 110.91 44.82 110.97 44.86 111.03C45.54 112.02 46.24 113.14 46.9 114.35C46.99 114.48 47.07 114.62 47.15 114.77C50.35 120.59 53.01 127.75 53.21 128.29V128.32V128.33Z"
          fill="url(#paint10_linear_792_417)"
        />
        <g opacity="0.5">
          <path
            d="M36.43 38.7C31.69 42.33 27.04 48.57 24.64 52.96C22.22 57.11 20.47 61.69 19.18 66.32L17.79 65.7C15.75 64.87 13.57 63.77 11.45 63.77C11.45 63.77 11.72 63.67 11.79 63.57C11.85 63.53 11.96 63.41 11.97 63.38C11.97 63.4 11.82 63.85 11.77 64.21C10.78 74.1 12.72 87.57 18.39 95.86L19.91 98.01L17.38 98.59L7.85 100.77L9.04 98.46L9.21 98.93C16.12 115.62 35.53 125.17 53.24 128.23L53.21 128.42C43.88 127.21 34.62 124.61 26.44 119.86C18.24 115.1 10.89 108.08 7.3 99.17L7.23 98.98L7.42 98.93L16.93 96.69L16.82 96.99C14.65 93.99 13.21 90.55 12.18 87.03C10.19 79.98 9.32 72.56 9.92 65.25C10.1 64.3 10.04 62.93 10.84 62.22C11.19 62.1 11.57 62.08 11.93 62.12C14.23 62.42 16.35 63.45 18.43 64.4L18.23 64.49C20.46 57.48 23.99 51.05 28.76 45.5C30.97 42.97 33.49 40.47 36.32 38.53L36.43 38.7Z"
            fill="#1A2819"
          />
        </g>
        <path
          d="M53.01 121.32C41.99 110.89 31.01 77.29 25.3 57.54C24.77 55.72 24.29 54.02 23.84 52.46C24.24 51.8 24.65 51.17 25.05 50.56C25.29 50.19 25.54 49.82 25.8 49.47C26.29 48.77 26.8 48.09 27.3 47.45C27.78 46.83 28.25 46.26 28.72 45.71C28.75 45.67 28.79 45.63 28.83 45.59C29.05 45.33 29.28 45.08 29.49 44.83C29.73 44.56 29.96 44.31 30.2 44.06C30.59 43.63 30.97 43.24 31.35 42.86C31.67 42.54 31.98 42.25 32.28 41.96C32.59 41.68 32.87 41.41 33.15 41.17C33.22 41.11 33.28 41.05 33.34 41C33.52 40.84 33.7 40.69 33.86 40.54C35.4 39.24 36.37 38.61 36.37 38.61C37.27 39.67 38.23 41.6 39.15 43.87C41.77 50.28 44.15 59.39 44.15 59.39C50.63 88.13 52.48 110.55 53.01 121.31V121.32Z"
          fill="#1A2819"
          opacity="0.5"
        />
        <path
          d="M100.73 121.46L107.54 128.47C107.54 128.47 107.49 128.51 107.39 128.58C107.35 128.61 107.31 128.65 107.26 128.68C107.18 128.73 107.1 128.8 107 128.87C105.88 129.67 103.01 131.5 98.54 133.05C96.28 133.84 93.62 134.55 90.55 135.03C90 135.11 89.44 135.19 88.86 135.26C86.94 135.49 84.89 135.62 82.69 135.61C82.34 135.61 81.99 135.61 81.65 135.61C80.87 135.59 80.07 135.56 79.25 135.51C78.89 135.49 78.53 135.46 78.16 135.43C77.77 135.4 77.37 135.36 76.97 135.32C76.56 135.27 76.16 135.23 75.74 135.18C75.33 135.13 74.93 135.08 74.53 135.02C73.87 134.92 73.22 134.82 72.54 134.7C72.17 134.63 71.8 134.57 71.43 134.49C71.04 134.42 70.65 134.33 70.24 134.24C65.06 133.12 59.4 131.25 53.25 128.36C53.25 128.36 53.26 128.36 53.26 128.34C53.39 128.13 54.71 126.07 57.21 122.57C63.47 113.79 77.14 95.93 98.12 75.24C98.12 75.24 105.32 68.6 111.03 64.65C112.91 63.36 114.63 62.35 115.88 61.96C115.88 61.96 115.91 62.02 115.96 62.15C116 62.23 116.04 62.35 116.1 62.49C116.19 62.7 116.29 62.98 116.42 63.32C116.49 63.53 116.57 63.74 116.65 63.99C117 65.04 117.42 66.48 117.82 68.25C117.93 68.77 118.04 69.31 118.14 69.88C118.21 70.22 118.26 70.55 118.32 70.91C118.37 71.23 118.42 71.57 118.47 71.91C118.48 71.97 118.49 72.02 118.49 72.07C118.59 72.78 118.68 73.53 118.75 74.3C118.83 75.11 118.89 75.95 118.93 76.81C118.96 77.25 118.97 77.69 118.97 78.13C118.98 78.86 118.99 79.61 118.97 80.37C118.97 80.67 118.96 80.95 118.94 81.24C118.93 81.55 118.92 81.87 118.9 82.18C118.87 82.62 118.84 83.07 118.8 83.52C118.77 84.01 118.72 84.5 118.66 85C118.62 85.37 118.58 85.74 118.52 86.13C118.5 86.39 118.45 86.65 118.41 86.92C118.35 87.37 118.28 87.83 118.19 88.3C118.14 88.64 118.07 88.98 118 89.33C117.86 90.12 117.69 90.93 117.49 91.74C117.35 92.32 117.21 92.92 117.04 93.51C117.04 93.51 123.38 94.21 124.49 95.69C125.13 96.54 121.5 103.26 115.82 109.78C111.62 114.61 106.29 119.33 100.74 121.48L100.73 121.46Z"
          fill="url(#paint11_linear_792_417)"
        />
        <path
          d="M100.73 121.46L107.54 128.47C107.54 128.47 107.49 128.51 107.39 128.58C107.35 128.61 107.31 128.65 107.26 128.68C107.18 128.73 107.1 128.8 107 128.87C105.88 129.67 103.01 131.5 98.54 133.05C96.28 133.84 93.62 134.55 90.55 135.03C90 135.11 89.44 135.19 88.86 135.26C86.94 135.49 84.89 135.62 82.69 135.61C82.34 135.61 81.99 135.61 81.65 135.61C80.87 135.59 80.07 135.56 79.25 135.51C78.89 135.49 78.53 135.46 78.16 135.43C77.77 135.4 77.37 135.36 76.97 135.32C76.56 135.27 76.16 135.23 75.74 135.18C75.33 135.13 74.93 135.08 74.53 135.02C73.87 134.92 73.22 134.82 72.54 134.7C72.17 134.63 71.8 134.57 71.43 134.49C71.04 134.42 70.65 134.33 70.24 134.24C65.06 133.12 59.4 131.25 53.25 128.36C53.25 128.36 53.26 128.36 53.26 128.34H53.27C53.27 128.34 53.33 128.29 53.38 128.24C54.15 127.57 58.33 124.03 65.68 120.23C65.83 120.15 65.97 120.07 66.11 120.01C67.21 119.44 68.38 118.88 69.62 118.32C78.96 114.09 92.14 110.04 108.91 109.7C111.14 109.66 113.44 109.68 115.81 109.78C111.61 114.61 106.28 119.33 100.73 121.48V121.46Z"
          fill="url(#paint12_linear_792_417)"
        />
        <path
          d="M98.53 133.06C96.27 133.85 93.61 134.56 90.54 135.04C89.99 135.12 89.43 135.2 88.85 135.27C86.93 135.5 84.88 135.63 82.68 135.62C82.33 135.62 81.98 135.62 81.64 135.62C80.86 135.6 80.06 135.57 79.24 135.52C78.88 135.5 78.52 135.47 78.15 135.44C77.76 135.41 77.36 135.37 76.96 135.33C76.55 135.28 76.15 135.24 75.73 135.19C75.32 135.14 74.92 135.09 74.52 135.03C73.86 134.93 73.21 134.83 72.53 134.71C72.16 134.64 71.79 134.58 71.42 134.5C71.03 134.43 70.64 134.34 70.23 134.25C65.05 133.13 59.39 131.26 53.24 128.37C53.24 128.37 53.25 128.37 53.25 128.35H53.26C53.26 128.35 53.32 128.3 53.37 128.25C54.36 127.53 60.14 123.25 65.67 120.24C65.82 120.16 65.96 120.08 66.1 120.02C67.31 119.36 68.5 118.79 69.61 118.33C69.68 118.3 69.75 118.28 69.82 118.25C69.82 118.25 73.47 123.63 87.84 129.4C90.9 130.63 94.43 131.88 98.53 133.09V133.06Z"
          fill="url(#paint13_linear_792_417)"
        />
        <g opacity="0.5">
          <path
            d="M115.96 61.89C119.45 70.88 119.88 80.87 117.92 90.28C117.71 91.37 117.44 92.45 117.16 93.53L117.04 93.35C118.86 93.58 120.68 93.87 122.44 94.42C123.21 94.69 124.06 94.96 124.6 95.61C124.9 96.63 124.09 97.77 123.74 98.66C118.71 107.78 110.56 117.54 100.78 121.64L100.85 121.33L107.65 128.35L107.79 128.49L107.63 128.62C96.9 136.16 82.72 137.07 70.2 134.35C65.67 133.45 58.29 130.94 53.19 128.43L53.27 128.25C56.06 129.36 58.88 130.37 61.73 131.25C64.59 132.12 67.48 132.82 70.4 133.32L71.01 133.78C70.97 133.73 70.99 133.68 70.73 133.47C70.6 133.39 70.47 133.32 70.3 133.31C69.87 133.23 69.39 133.66 69.34 133.94L70.41 133.33C73.51 133.91 76.69 134.27 79.8 134.36C88.98 134.71 99.75 132.22 106.54 127.08L106.29 129.66L99.45 122.68L97.63 120.82C101.69 119.35 105.46 117.25 108.8 114.31C114.32 109.4 119.47 103.41 122.74 96.78C122.89 96.45 123.01 95.99 123.02 95.97C123.02 96.01 123.02 95.97 123.03 96.09C123.03 96.14 123.05 96.17 123.07 96.22C123.09 96.37 123.26 96.56 123.24 96.57C121.45 95.43 119.02 95.17 116.86 94.77L115.35 94.54L115.75 93.14C117.48 87.31 118.14 81.68 118.05 76.15C117.99 73.14 117.74 69.97 117.04 67.03C116.73 65.66 116.33 63.47 115.81 62.16L115.75 61.98L115.92 61.89H115.96Z"
            fill="#1A2819"
          />
        </g>
        <path
          d="M118.95 80.34C117.87 81.3 116.71 82.33 115.46 83.43C100.06 96.91 72.27 119.7 57.21 122.54C63.47 113.76 77.14 95.9 98.12 75.21C98.12 75.21 105.32 68.57 111.03 64.62C112.91 63.33 114.63 62.32 115.88 61.93C115.88 61.93 115.91 61.99 115.96 62.12C116 62.2 116.04 62.32 116.1 62.46C116.19 62.67 116.29 62.95 116.42 63.29C116.49 63.5 116.57 63.71 116.65 63.96C117 65.01 117.42 66.45 117.82 68.22C117.93 68.74 118.04 69.28 118.14 69.85C118.21 70.19 118.26 70.52 118.32 70.88C118.37 71.2 118.42 71.54 118.47 71.88C118.48 71.94 118.49 71.99 118.49 72.04C118.59 72.75 118.68 73.5 118.75 74.27C118.83 75.08 118.89 75.92 118.93 76.78C118.96 77.22 118.97 77.66 118.97 78.1C118.98 78.83 118.99 79.58 118.97 80.34H118.95Z"
          fill="#1A2819"
          opacity="0.5"
        />
        <g style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M53.21 128.31V128.33C46.72 127.48 41.12 126.07 36.28 124.31C31.32 120.52 27.16 115.85 24 110.59C19.04 102.39 16.47 92.77 16.93 82.88C16.94 82.63 16.96 82.37 16.97 82.11C17.19 78.5 17.82 74.84 18.89 71.22C20.36 66.23 22.54 61.63 25.31 57.53C29.01 52.03 33.74 47.41 39.17 43.87C41.79 50.28 44.17 59.39 44.17 59.39C50.65 88.13 52.5 110.55 53.03 121.31C53.23 125.61 53.23 128.05 53.23 128.3L53.21 128.31Z"
            fill="black"
          />
        </g>
        <g style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M113.48 98.98C113.17 100.03 112.84 101.05 112.46 102.06C111.48 104.74 110.29 107.29 108.9 109.69C103.93 118.36 96.51 125.12 87.83 129.38C82.36 132.05 76.4 133.73 70.22 134.24C65.04 133.12 59.38 131.25 53.23 128.36C53.23 128.36 53.24 128.36 53.24 128.34C53.37 128.13 54.69 126.07 57.19 122.57C63.45 113.79 77.12 95.93 98.1 75.24C98.1 75.24 105.3 68.6 111.01 64.65C113.68 70.5 115.23 76.88 115.44 83.45C115.62 88.57 114.99 93.8 113.47 98.99L113.48 98.98Z"
            fill="black"
          />
        </g>
        <path d="M96.22 52.32L69.05 75.09L58.48 41.25L85.65 18.49L96.22 52.32Z" fill="#162116" />
        <path d="M96.22 52.32L69.05 75.09L77.35 46.79L85.65 18.49L96.22 52.32Z" fill="#070B0B" />
        <path d="M88.24 59.01L69.05 75.09L61.58 51.19L80.78 35.11L88.24 59.01Z" fill="#1D2021" opacity="0.5" />
        <path d="M80.78 35.11L58.48 41.25L85.65 18.49L80.78 35.11Z" fill="#1A2819" opacity="0.5" />
        <path d="M69.05 75.09L83.69 19.96L85.65 18.49L86.51 20.79L69.05 75.09Z" fill="#C3DFDF" opacity="0.49" />
        <path d="M58.48 41.25L85.65 18.49L84.91 21.04L58.48 41.25Z" fill="#C3DFDF" opacity="0.45" />
        <path d="M96.22 52.32L85.65 18.49L84.91 21.04L96.22 52.32Z" fill="#C3DFDF" opacity="0.45" />
        <path
          d="M104.36 44.24L96.71 59.09L95.67 61.08L92.61 67.03L87.9 66.58L75.05 65.36L67.1 64.6L69.38 60.16L76.1 47.1L78.83 41.8L87.71 42.65L99.42 43.77L104.36 44.24Z"
          fill="url(#paint14_linear_792_417)"
        />
        <path d="M78.83 41.8L85.72 54.42L104.35 44.24L78.83 41.8Z" fill="url(#paint15_linear_792_417)" />
        <path
          d="M92.61 67.03L85.72 54.42L104.35 44.24L92.61 67.03Z"
          fill="url(#paint16_linear_792_417)"
          opacity="0.63"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path d="M67.09 64.59L85.72 54.42L78.83 41.8L67.09 64.59Z" fill="#1A2819" opacity="0.5" />
        <path d="M78.83 41.8L104.35 44.24L94.34 49.71L101.33 44.83L78.83 41.8Z" fill="#C3DFDF" opacity="0.45" />
        <path
          d="M76.4 67.33L61.56 59.68L59.56 58.65L53.61 55.58L54.06 50.87L55.29 38.03L56.05 30.07L60.48 32.36L73.55 39.08L78.84 41.8L77.99 50.68L76.87 62.39L76.4 67.33Z"
          fill="url(#paint17_linear_792_417)"
        />
        <path d="M78.84 41.8L66.23 48.7L76.41 67.33L78.84 41.8Z" fill="url(#paint18_linear_792_417)" />
        <path
          d="M53.61 55.59L66.23 48.7L76.41 67.33L53.61 55.59Z"
          fill="url(#paint19_linear_792_417)"
          opacity="0.63"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path d="M56.05 30.07L66.23 48.7L78.84 41.8L56.05 30.07Z" fill="#1A2819" opacity="0.5" />
        <path d="M78.84 41.81L56.05 30.06L61.52 40.08L58.28 32.2L78.84 41.81Z" fill="#C3DFDF" opacity="0.45" />
        <path
          d="M109.56 97.82C109.28 98.78 108.97 99.72 108.63 100.65C100.52 122.84 76.45 135.21 53.46 128.47C32.84 122.42 19.8 102.95 21.06 82.37C21.27 79.05 21.84 75.7 22.82 72.37C29.85 48.41 54.97 34.69 78.92 41.71C102.88 48.74 116.6 73.86 109.57 97.82H109.56Z"
          fill="url(#paint20_linear_792_417)"
        />
        <path
          d="M111.22 83.87C74.86 87.37 45.73 71.16 29.23 58.76C40.09 43.53 59.79 36.1 78.74 41.66C98.06 47.33 110.72 64.77 111.22 83.87Z"
          fill="url(#paint21_linear_792_417)"
        />
        <path
          d="M111.22 83.87C74.86 87.37 45.73 71.16 29.23 58.76C40.09 43.53 59.79 36.1 78.74 41.66C98.06 47.33 110.72 64.77 111.22 83.87Z"
          fill="#1A2819"
        />
        <path
          d="M108.13 100.5C100.02 122.69 75.95 135.06 52.96 128.32C32.34 122.27 19.3 102.8 20.56 82.22C27.83 88.86 39.04 96.83 54.25 101.3C73.27 106.88 95.15 103.54 108.14 100.51L108.13 100.5Z"
          fill="url(#paint22_linear_792_417)"
        />
        <g opacity="0.5">
          <path
            d="M66.17 39.87V41.83C70.27 41.83 74.37 42.42 78.35 43.59C89.43 46.84 98.59 54.22 104.13 64.35C109.67 74.49 110.93 86.17 107.68 97.26C107.4 98.23 107.1 99.11 106.79 99.97C100.59 116.94 84.28 128.34 66.21 128.34C62.1 128.34 58 127.75 54.02 126.58C44.57 123.81 36.28 117.83 30.67 109.75C25.15 101.78 22.43 92.1 23.02 82.49C23.22 79.26 23.79 76.04 24.7 72.92C27.38 63.77 32.85 55.95 40.5 50.31C47.91 44.85 57.03 41.84 66.18 41.84V39.88M66.17 39.87C46.62 39.87 28.59 52.66 22.81 72.37C21.83 75.7 21.26 79.05 21.05 82.37C19.79 102.95 32.83 122.42 53.45 128.47C57.7 129.72 61.98 130.31 66.2 130.31C84.8 130.31 102.02 118.74 108.63 100.65C108.97 99.73 109.28 98.78 109.56 97.82C116.59 73.86 102.86 48.74 78.91 41.71C74.66 40.46 70.38 39.87 66.17 39.87Z"
            fill="#1A2819"
          />
        </g>
        <path
          d="M97.21 94.19C97.01 94.88 96.79 95.55 96.54 96.21C90.74 112.08 73.52 120.93 57.08 116.11C42.33 111.78 33 97.86 33.9 83.14C34.05 80.77 34.46 78.37 35.16 75.99C40.19 58.85 58.16 49.04 75.29 54.06C92.43 59.09 102.24 77.06 97.22 94.19H97.21Z"
          fill="url(#paint23_linear_792_417)"
        />
        <path
          d="M97.21 94.19C97.01 94.88 96.79 95.55 96.54 96.21C90.74 112.08 73.52 120.93 57.08 116.11C42.33 111.78 33 97.86 33.9 83.14C34.05 80.77 34.46 78.37 35.16 75.99C40.19 58.85 58.16 49.04 75.29 54.06C92.43 59.09 102.24 77.06 97.22 94.19H97.21Z"
          fill="url(#paint24_linear_792_417)"
        />
        <g opacity="0.5">
          <path
            d="M66.17 52.75C69.18 52.75 72.24 53.17 75.28 54.07C92.42 59.1 102.23 77.07 97.21 94.2C97.01 94.89 96.79 95.56 96.54 96.22C91.81 109.16 79.49 117.43 66.19 117.43C63.18 117.43 60.11 117.01 57.07 116.11C42.32 111.78 32.99 97.86 33.89 83.14C34.04 80.77 34.45 78.37 35.15 75.99C39.29 61.89 52.18 52.75 66.17 52.75ZM66.17 50.78C51.06 50.78 37.53 60.92 33.27 75.43C32.55 77.9 32.1 80.45 31.94 83.01C31.47 90.64 33.63 98.32 38.01 104.64C42.45 111.05 49.03 115.79 56.53 117.99C59.69 118.92 62.94 119.39 66.2 119.39C80.54 119.39 93.48 110.35 98.39 96.89C98.64 96.22 98.87 95.52 99.1 94.75C101.68 85.96 100.68 76.69 96.29 68.65C91.9 60.61 84.64 54.76 75.84 52.18C72.69 51.25 69.44 50.79 66.18 50.79L66.17 50.78Z"
            fill="#1A2819"
          />
        </g>
        <path
          d="M98.43 87.52C94.41 82.41 88.83 78.46 82.12 76.49C65 71.47 47.03 81.28 42 98.42C41.35 100.63 40.94 102.86 40.78 105.07C35.96 98.95 33.42 91.16 33.91 83.14C34.06 80.77 34.47 78.37 35.17 76C40.2 58.87 58.17 49.04 75.3 54.07C90.21 58.44 99.58 72.63 98.44 87.53L98.43 87.52Z"
          fill="url(#paint25_linear_792_417)"
          opacity="0.5"
        />
        <path
          d="M109.65 97.8499C99.09 133.14 53.54 142.08 30.62 113.2C24 104.71 19.81 92.8199 21.15 82.3799C21.18 93.2299 24.91 103.96 31.82 112.26C51.3 136.06 89.03 133.15 104.98 106.97C106.01 105.37 107.09 103.32 107.86 101.58C108.52 100.37 108.93 99.07 109.47 97.7999L109.66 97.8599L109.65 97.8499Z"
          fill="#25382D"
        />
        <path
          d="M64.76 52.63C85.61 51.58 102.19 70.64 98.15 91.15C97.15 96.03 95.17 100.71 92.11 104.66L91.87 104.48C93.62 101.05 94.86 97.63 95.61 93.97C98.42 80.71 92.69 66.25 81.22 58.89C76.47 55.71 70.85 53.69 64.76 52.92V52.63Z"
          fill="black"
        />
        <g opacity="0.15">
          <path
            d="M33.54 66.93C36.43 60.38 42.04 55.3 48.31 52.02C55.85 48.08 65.16 46.23 73.44 48.7C76.48 49.6 77.77 44.87 74.75 43.96C67.3 41.74 59.43 42.64 52.16 45.09C45.54 47.32 39.37 51.15 34.68 56.37C32.52 58.78 30.61 61.47 29.3 64.44C28.77 65.65 28.95 67.08 30.18 67.8C31.22 68.41 33 68.14 33.54 66.92V66.93Z"
            fill="white"
          />
        </g>
        <path
          d="M81.72 134.96C80.1 137.32 77.4 138.71 74.53 138.67L61.26 138.51L50.18 138.37L53.51 127.01L71.33 125.2L87.66 123.54C86.88 126.99 83.96 131.7 81.71 134.96H81.72Z"
          fill="url(#paint26_linear_792_417)"
        />
        <g opacity="0.75" style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M50.19 138.27C56.77 137.63 66.35 137.35 73.06 137.14C76.86 137.4 79.33 135.96 81.13 132.76C83 129.78 85.09 126.48 85.99 123.17L87.84 125.26C84.99 125.54 82.14 125.76 79.29 125.98C70.71 126.58 62.13 127.1 53.53 127.12L53.51 126.92L87.65 123.37L87.9 123.34C87.47 125.32 86.61 127.15 85.68 128.92C83.32 132.88 81.06 138.13 75.9 138.74C75.17 138.93 51.72 138.47 50.17 138.48V138.28L50.19 138.27Z"
            fill="#C3DFDF"
          />
        </g>
        <path
          d="M53.52 127.01L50.19 138.37L37.79 130.63L29.53 125.46C27.1 123.95 25.58 121.32 25.48 118.46C25.36 114.5 25.44 108.96 26.64 105.64L38.26 114.88L53.51 127.01H53.52Z"
          fill="url(#paint27_linear_792_417)"
        />
        <g opacity="0.75" style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M50.13 138.45L30.72 126.39C29.07 125.44 27.43 124.27 26.48 122.55C25.46 120.88 25.23 118.86 25.26 116.96C25.25 113.15 25.25 109.25 26.47 105.58L26.55 105.34L26.75 105.5L53.57 126.94L53.45 127.09C51.01 125.56 48.67 123.9 46.29 122.3C39.25 117.37 32.32 112.29 25.56 106.99L28.25 106.23C27.22 109.51 27.2 113.41 27.16 116.94C26.95 120.6 28.25 123.16 31.59 124.99C34.88 127.25 42.55 132.51 45.64 134.85C47.19 135.97 48.72 137.11 50.22 138.3L50.12 138.47L50.13 138.45Z"
            fill="#C3DFDF"
          />
        </g>
        <g style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M70.58 132.85C68.64 136.16 64.77 137.65 61.26 138.51L50.18 138.37L37.78 130.63C37.35 129.69 37.03 128.7 36.83 127.7C36.13 124.22 37.07 121.07 39.35 118.78C38.62 117.73 38.18 116.4 38.26 114.89L53.51 127.02L71.33 125.21C72.08 128.15 71.82 130.73 70.57 132.86L70.58 132.85Z"
            fill="black"
          />
        </g>
        <path
          d="M72.79 140L56.88 145.09L54.74 145.77L48.37 147.81L45.35 144.16L37.14 134.2L32.05 128.04L36.8 126.52L50.79 122.04L56.46 120.22L62.14 127.1L69.63 136.17L72.79 140Z"
          fill="url(#paint28_linear_792_417)"
        />
        <path d="M56.46 120.22L52.42 134.02L72.79 139.99L56.46 120.22Z" fill="url(#paint29_linear_792_417)" />
        <path
          d="M48.37 147.81L52.42 134.02L72.79 139.99L48.37 147.81Z"
          fill="url(#paint30_linear_792_417)"
          opacity="0.63"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path d="M32.05 128.04L52.42 134.02L56.46 120.22L32.05 128.04Z" fill="#1A2819" opacity="0.5" />
        <g style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M69.63 136.17C69.52 136.41 69.4 136.65 69.26 136.89C67.16 140.47 62.62 141.84 58.89 142.63C58.36 142.74 57.29 142.86 56.03 142.95L56.89 145.08L54.75 145.76L53.68 145.48C51.7 144.96 50.23 144.07 49.32 143.37C48.31 143.68 46.92 144.09 45.36 144.15L37.14 134.2C36.83 133.44 36.59 132.67 36.43 131.88C36.04 129.95 36.19 128.12 36.81 126.51L50.8 122.03L50.67 123.14C50.46 124.85 49.79 126.03 48.67 126.63C47.87 127.07 47.04 127.1 46.26 126.97C47.63 127.54 49.85 127.79 52.04 127.57C55.9 127.18 59.39 127.08 62.15 127.1L69.64 136.18L69.63 136.17Z"
            fill="black"
          />
        </g>
        <g filter="url(#filter0_d_792_417)">
          <path
            d="M67.86 129.33C67.56 129.27 60.9 128.65 52.23 129.52C47.57 129.98 41.26 128.69 43.47 123.85C44.37 123.64 48.18 127.26 48.72 122.9C47.76 123.11 45.05 121.36 43.88 122.62C43.78 120.98 40.74 119.52 40.02 118.16C39.3 120.77 40.72 122.48 42.45 123.19C38.77 125.07 37.73 128.3 38.37 131.49C39.01 134.68 41.32 137.84 44.32 139.58C44.61 140.11 43.65 141.2 42.28 141.68C45.23 142.93 48.19 141.56 49.79 141.19C50.6 141.98 52.15 143.03 54.18 143.57C53.92 142.92 53.83 141.96 53.97 141.08C55.98 141 57.84 140.84 58.49 140.7C64.63 139.4 70.23 136.92 67.87 129.32"
            fill="url(#paint31_linear_792_417)"
          />
          <path
            d="M67.86 129.33C67.56 129.27 60.9 128.65 52.23 129.52C47.57 129.98 41.26 128.69 43.47 123.85C43.47 123.85 41.53 126.89 43.51 128.89C44.43 129.81 47.05 131.03 49.54 130.67C60.72 129.07 67.87 129.33 67.87 129.33H67.86Z"
            fill="#1A2819"
          />
          <path
            d="M40.01 118.16C40.67 119.51 43.77 120.98 43.87 122.62C45.05 121.36 47.76 123.11 48.71 122.9C48.71 122.9 44.51 121.95 43.63 123C43.63 123 43 121.56 42.01 120.84C41.02 120.12 40 119.49 40 118.16H40.01Z"
            fill="#1A2819"
          />
          <path
            d="M44.3 139.6C41.62 138.27 38.99 134.7 38.35 131.51C37.71 128.32 38.75 125.09 42.43 123.21C42.43 123.21 33.02 129.49 44.3 139.61V139.6Z"
            fill="#1A2819"
          />
          <path
            d="M67.86 129.33C70.22 136.93 64.62 139.4 58.48 140.71C57.83 140.85 55.97 141.02 53.96 141.09C53.96 141.09 70.21 139.79 67.86 129.33Z"
            fill="#1A2819"
          />
          <path
            d="M42.26 141.69C42.26 141.69 44.52 143.19 49.77 141.2L51.51 140.38C51.51 140.38 44.89 142.63 42.26 141.7V141.69Z"
            fill="#C3DFDF"
            opacity="0.5"
          />
        </g>
        <path
          d="M105.29 80.29C114.165 80.29 121.36 73.0952 121.36 64.22C121.36 55.3447 114.165 48.15 105.29 48.15C96.4148 48.15 89.22 55.3447 89.22 64.22C89.22 73.0952 96.4148 80.29 105.29 80.29Z"
          fill="url(#paint32_radial_792_417)"
          opacity="0.65"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M114.852 68.6374C117.295 63.354 114.993 57.0901 109.71 54.6466C104.427 52.2031 98.1626 54.5053 95.7191 59.7887C93.2756 65.0721 95.5778 71.336 100.861 73.7795C106.145 76.223 112.408 73.9208 114.852 68.6374Z"
          fill="url(#paint33_radial_792_417)"
          opacity="0.67"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M91.85 71.47C92.81 73.23 99.5 71.43 106.8 67.45C114.1 63.47 119.22 58.81 118.26 57.05C117.3 55.29 110.61 57.09 103.31 61.07C96.02 65.05 90.89 69.71 91.85 71.47Z"
          fill="url(#paint34_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M100.97 66.49C101.27 67.04 103.34 66.48 105.6 65.24C107.86 64.01 109.45 62.56 109.15 62.02C108.85 61.48 106.78 62.03 104.52 63.27C102.26 64.5 100.67 65.95 100.97 66.49Z"
          fill="url(#paint35_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M99.48 67.3C99.89 68.04 102.71 67.28 105.79 65.6C108.87 63.92 111.03 61.95 110.63 61.21C110.22 60.47 107.4 61.23 104.32 62.91C101.24 64.59 99.08 66.56 99.48 67.3Z"
          fill="url(#paint36_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M84.51 75.68C84.28 75.45 92.98 70.32 103.94 64.23C114.9 58.13 123.97 53.38 124.21 53.61C124.44 53.84 115.74 58.97 104.78 65.06C93.82 71.16 84.75 75.91 84.51 75.68Z"
          fill="url(#paint37_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M97.53 52.13C95.77 53.09 97.57 59.78 101.55 67.08C105.53 74.37 110.19 79.5 111.95 78.54C113.71 77.58 111.91 70.89 107.93 63.59C103.95 56.3 99.29 51.17 97.53 52.13Z"
          fill="url(#paint38_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M102.51 61.25C101.96 61.55 102.52 63.62 103.76 65.88C104.99 68.14 106.44 69.73 106.98 69.43C107.53 69.13 106.97 67.06 105.73 64.8C104.5 62.54 103.05 60.95 102.51 61.25Z"
          fill="url(#paint39_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M101.7 59.76C100.96 60.17 101.72 62.99 103.4 66.07C105.08 69.15 107.05 71.31 107.79 70.91C108.53 70.5 107.77 67.68 106.09 64.6C104.41 61.52 102.44 59.36 101.7 59.76Z"
          fill="url(#paint40_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M93.32 44.79C93.55 44.56 98.68 53.26 104.77 64.22C110.87 75.18 115.62 84.25 115.39 84.49C115.16 84.72 110.03 76.02 103.94 65.06C97.84 54.1 93.09 45.03 93.32 44.79Z"
          fill="url(#paint41_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M107.4 63.15C106.54 61.58 104.58 61.01 103.02 61.86C101.45 62.72 100.88 64.68 101.73 66.24C102.58 67.8 104.55 68.38 106.11 67.53C107.68 66.67 108.25 64.71 107.4 63.15Z"
          fill="url(#paint42_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M110.203 66.3546C111.116 63.2437 109.334 59.9821 106.223 59.0695C103.112 58.1569 99.8504 59.9389 98.9378 63.0497C98.0252 66.1605 99.8072 69.4221 102.918 70.3347C106.029 71.2474 109.29 69.4654 110.203 66.3546Z"
          fill="url(#paint43_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M33.67 110.56C42.5452 110.56 49.74 103.365 49.74 94.49C49.74 85.6148 42.5452 78.42 33.67 78.42C24.7948 78.42 17.6 85.6148 17.6 94.49C17.6 103.365 24.7948 110.56 33.67 110.56Z"
          fill="url(#paint44_radial_792_417)"
          opacity="0.65"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M43.2321 98.9184C45.6756 93.635 43.3734 87.3711 38.09 84.9276C32.8066 82.4841 26.5427 84.7863 24.0992 90.0697C21.6557 95.3531 23.9579 101.617 29.2413 104.06C34.5247 106.504 40.7886 104.202 43.2321 98.9184Z"
          fill="url(#paint45_radial_792_417)"
          opacity="0.67"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M20.24 101.74C21.2 103.5 27.89 101.7 35.19 97.72C42.48 93.74 47.61 89.08 46.65 87.32C45.69 85.56 39 87.36 31.7 91.34C24.41 95.32 19.28 99.98 20.24 101.74Z"
          fill="url(#paint46_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M29.35 96.7601C29.65 97.3101 31.72 96.7501 33.98 95.5101C36.24 94.2801 37.83 92.8301 37.53 92.2901C37.23 91.7501 35.16 92.3001 32.9 93.5401C30.64 94.7701 29.05 96.2201 29.35 96.7601Z"
          fill="url(#paint47_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M27.87 97.57C28.28 98.31 31.1 97.55 34.18 95.87C37.26 94.19 39.42 92.22 39.02 91.48C38.61 90.74 35.79 91.5 32.71 93.18C29.63 94.86 27.47 96.83 27.87 97.57Z"
          fill="url(#paint48_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M12.9 105.95C12.67 105.72 21.37 100.59 32.33 94.5C43.29 88.4 52.36 83.65 52.6 83.88C52.83 84.11 44.13 89.24 33.17 95.33C22.21 101.43 13.14 106.18 12.9 105.95Z"
          fill="url(#paint49_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M25.91 82.41C24.15 83.37 25.95 90.06 29.93 97.36C33.91 104.65 38.57 109.78 40.33 108.82C42.09 107.86 40.29 101.17 36.31 93.87C32.33 86.58 27.67 81.45 25.91 82.41Z"
          fill="url(#paint50_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M30.89 91.52C30.34 91.82 30.9 93.89 32.14 96.15C33.37 98.41 34.82 100 35.36 99.7C35.91 99.4 35.35 97.33 34.11 95.07C32.88 92.81 31.43 91.22 30.89 91.52Z"
          fill="url(#paint51_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M30.08 90.04C29.34 90.45 30.1 93.27 31.78 96.35C33.46 99.43 35.43 101.59 36.17 101.19C36.91 100.78 36.15 97.96 34.47 94.88C32.79 91.8 30.82 89.64 30.08 90.04Z"
          fill="url(#paint52_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M21.7 75.06C21.93 74.83 27.06 83.53 33.15 94.49C39.25 105.45 44 114.52 43.77 114.76C43.54 114.99 38.41 106.29 32.32 95.33C26.22 84.37 21.47 75.3 21.7 75.06Z"
          fill="url(#paint53_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M35.79 93.42C34.93 91.85 32.97 91.28 31.41 92.13C29.84 92.99 29.27 94.95 30.12 96.51C30.97 98.07 32.94 98.65 34.5 97.8C36.07 96.94 36.64 94.98 35.79 93.42Z"
          fill="url(#paint54_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M38.5904 96.6198C39.503 93.509 37.721 90.2474 34.6102 89.3348C31.4994 88.4222 28.2378 90.2041 27.3252 93.315C26.4126 96.4258 28.1946 99.6874 31.3054 100.6C34.4162 101.513 37.6778 99.7306 38.5904 96.6198Z"
          fill="url(#paint55_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M73.68 118.81C76.9716 118.81 79.64 116.142 79.64 112.85C79.64 109.558 76.9716 106.89 73.68 106.89C70.3884 106.89 67.72 109.558 67.72 112.85C67.72 116.142 70.3884 118.81 73.68 118.81Z"
          fill="url(#paint56_radial_792_417)"
          opacity="0.65"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M77.2336 114.488C78.14 112.528 77.286 110.204 75.326 109.298C73.3661 108.391 71.0424 109.245 70.1359 111.205C69.2294 113.165 70.0835 115.489 72.0434 116.396C74.0034 117.302 76.3271 116.448 77.2336 114.488Z"
          fill="url(#paint57_radial_792_417)"
          opacity="0.67"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M68.69 115.54C69.05 116.19 71.53 115.53 74.24 114.05C76.95 112.57 78.85 110.84 78.49 110.19C78.13 109.54 75.65 110.2 72.94 111.68C70.23 113.16 68.33 114.89 68.69 115.54Z"
          fill="url(#paint58_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M72.07 113.69C72.18 113.89 72.95 113.69 73.79 113.23C74.63 112.77 75.22 112.24 75.11 112.03C75 111.82 74.23 112.03 73.39 112.49C72.55 112.95 71.96 113.48 72.07 113.69Z"
          fill="url(#paint59_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M71.52 113.99C71.67 114.27 72.72 113.99 73.86 113.36C75 112.74 75.81 112.01 75.65 111.73C75.5 111.45 74.45 111.73 73.31 112.36C72.17 112.99 71.36 113.71 71.52 113.99Z"
          fill="url(#paint60_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M65.97 117.1C65.88 117.01 69.11 115.11 73.18 112.85C77.25 110.59 80.61 108.82 80.7 108.91C80.79 109 77.56 110.9 73.49 113.16C69.42 115.42 66.06 117.19 65.97 117.1Z"
          fill="url(#paint61_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M70.8 108.36C70.15 108.72 70.81 111.2 72.29 113.91C73.77 116.62 75.5 118.52 76.15 118.16C76.8 117.8 76.14 115.32 74.66 112.61C73.18 109.9 71.45 108 70.8 108.36Z"
          fill="url(#paint62_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M72.64 111.74C72.44 111.85 72.64 112.62 73.1 113.46C73.56 114.3 74.09 114.89 74.3 114.78C74.5 114.67 74.3 113.9 73.84 113.06C73.38 112.22 72.85 111.63 72.64 111.74Z"
          fill="url(#paint63_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M72.34 111.19C72.06 111.34 72.34 112.39 72.97 113.53C73.6 114.67 74.32 115.48 74.6 115.32C74.88 115.17 74.6 114.12 73.97 112.98C73.35 111.84 72.62 111.03 72.34 111.19Z"
          fill="url(#paint64_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M69.23 105.64C69.32 105.55 71.22 108.78 73.48 112.85C75.74 116.92 77.51 120.28 77.42 120.37C77.33 120.46 75.43 117.23 73.17 113.16C70.91 109.09 69.14 105.73 69.23 105.64Z"
          fill="url(#paint65_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <path
          d="M74.46 112.45C74.14 111.87 73.41 111.66 72.83 111.97C72.25 112.29 72.04 113.02 72.35 113.6C72.66 114.18 73.4 114.39 73.98 114.08C74.56 113.76 74.77 113.03 74.46 112.45Z"
          fill="url(#paint66_radial_792_417)"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M73.41 115.2C74.614 115.2 75.59 114.224 75.59 113.02C75.59 111.816 74.614 110.84 73.41 110.84C72.206 110.84 71.23 111.816 71.23 113.02C71.23 114.224 72.206 115.2 73.41 115.2Z"
          fill="url(#paint67_radial_792_417)"
          style={{ mixBlendMode: 'color-dodge' }}
        />
      </g>
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="33.25"
        id="filter0_d_792_417"
        width="38.0886"
        x="35.2333"
        y="114.24"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="0.98" />
        <feGaussianBlur stdDeviation="1.96" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_792_417" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_792_417" mode="normal" result="shape" />
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_792_417"
        x1="54.6961"
        x2="23.0958"
        y1="73.2008"
        y2="-8.53007"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_792_417"
        x1="49.6357"
        x2="20.6066"
        y1="93.6116"
        y2="18.5336"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_792_417"
        x1="45.8933"
        x2="18.6636"
        y1="113.544"
        y2="43.1314"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_792_417"
        x1="46.6141"
        x2="22.0664"
        y1="134.995"
        y2="71.4964"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_792_417"
        x1="82.3453"
        x2="153.092"
        y1="81.3311"
        y2="29.6255"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_792_417"
        x1="75.5769"
        x2="140.565"
        y1="101.241"
        y2="53.7447"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_792_417"
        x1="67.9579"
        x2="128.912"
        y1="120.036"
        y2="75.4937"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_792_417"
        x1="55.763"
        x2="110.724"
        y1="137.698"
        y2="97.5248"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_792_417"
        x1="18.9057"
        x2="37.0556"
        y1="43.0879"
        y2="136.849"
      >
        <stop stopColor="#5E6C62" />
        <stop offset="0.05" stopColor="#546258" />
        <stop offset="0.25" stopColor="#323E34" />
        <stop offset="0.41" stopColor="#1D281E" />
        <stop offset="0.52" stopColor="#162116" />
        <stop offset="1" stopColor="#050A0B" />
      </linearGradient>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint9_linear_792_417" x1="23.252" x2="34.5116" y1="77.1175" y2="135.29">
        <stop stopColor="#030809" stopOpacity="0.2" />
        <stop offset="0.97" stopColor="#1D2121" stopOpacity="0.98" />
        <stop offset="1" stopColor="#1D2021" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_792_417"
        x1="30.2947"
        x2="35.8359"
        y1="104.727"
        y2="133.333"
      >
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint11_linear_792_417"
        x1="80.6535"
        x2="93.9837"
        y1="69.5503"
        y2="138.355"
      >
        <stop stopColor="#5E6C62" />
        <stop offset="0.05" stopColor="#546258" />
        <stop offset="0.25" stopColor="#323E34" />
        <stop offset="0.41" stopColor="#1D281E" />
        <stop offset="0.52" stopColor="#162116" />
        <stop offset="1" stopColor="#050A0B" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint12_linear_792_417"
        x1="83.4134"
        x2="87.9855"
        y1="113.286"
        y2="136.919"
      >
        <stop stopColor="#030809" stopOpacity="0.2" />
        <stop offset="0.97" stopColor="#1D2121" stopOpacity="0.98" />
        <stop offset="1" stopColor="#1D2021" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint13_linear_792_417"
        x1="73.3871"
        x2="77.4598"
        y1="117.765"
        y2="138.802"
      >
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint14_linear_792_417"
        x1="78.7858"
        x2="92.2874"
        y1="41.7194"
        y2="66.4317"
      >
        <stop stopColor="#5E6C62" />
        <stop offset="0.52" stopColor="#162116" />
        <stop offset="1" stopColor="#050A0B" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint15_linear_792_417"
        x1="87.4138"
        x2="98.2281"
        y1="55.3632"
        y2="23.3484"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint16_linear_792_417" x1="85.5626" x2="115.77" y1="53.56" y2="58.3763">
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint17_linear_792_417"
        x1="78.919"
        x2="54.198"
        y1="41.7854"
        y2="55.2917"
      >
        <stop stopColor="#5E6C62" />
        <stop offset="0.52" stopColor="#162116" />
        <stop offset="1" stopColor="#050A0B" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint18_linear_792_417"
        x1="65.2705"
        x2="97.2901"
        y1="50.4046"
        y2="61.2277"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint19_linear_792_417"
        x1="67.0737"
        x2="62.2486"
        y1="48.5534"
        y2="78.7659"
      >
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint20_linear_792_417"
        x1="52.4449"
        x2="83.3344"
        y1="131.922"
        y2="26.6291"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint21_linear_792_417"
        x1="67.5026"
        x2="80.8177"
        y1="80.5948"
        y2="35.2076"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint22_linear_792_417"
        x1="53.4611"
        x2="65.3462"
        y1="128.458"
        y2="87.945"
      >
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint23_linear_792_417"
        x1="56.3578"
        x2="78.4531"
        y1="118.584"
        y2="43.2679"
      >
        <stop stopColor="#5E6C62" />
        <stop offset="0.52" stopColor="#162116" />
        <stop offset="1" stopColor="#050A0B" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint24_linear_792_417"
        x1="56.3578"
        x2="78.4531"
        y1="118.584"
        y2="43.2679"
      >
        <stop stopColor="#030809" stopOpacity="0.2" />
        <stop offset="0.97" stopColor="#1D2121" stopOpacity="0.98" />
        <stop offset="1" stopColor="#1D2021" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint25_linear_792_417"
        x1="36.0003"
        x2="97.3737"
        y1="73.0934"
        y2="91.0985"
      >
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint26_linear_792_417"
        x1="87.4941"
        x2="50.5062"
        y1="123.247"
        y2="138.992"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint27_linear_792_417"
        x1="49.3762"
        x2="28.2396"
        y1="117.338"
        y2="126.332"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint28_linear_792_417"
        x1="56.4842"
        x2="48.557"
        y1="120.142"
        y2="147.164"
      >
        <stop stopColor="#5E6C62" />
        <stop offset="0.52" stopColor="#162116" />
        <stop offset="1" stopColor="#050A0B" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint29_linear_792_417"
        x1="52.9375"
        x2="83.2318"
        y1="135.891"
        y2="120.903"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint30_linear_792_417"
        x1="52.9035"
        x2="70.8579"
        y1="133.307"
        y2="158.073"
      >
        <stop stopColor="#1D2021" />
        <stop offset="1" stopColor="#030809" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint31_linear_792_417"
        x1="36.9111"
        x2="67.2524"
        y1="128.709"
        y2="137.61"
      >
        <stop stopColor="#050A0B" />
        <stop offset="0.48" stopColor="#162116" />
        <stop offset="1" stopColor="#5E6C62" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(105.282 64.2306) rotate(61.35) scale(16.07)"
        gradientUnits="userSpaceOnUse"
        id="paint32_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(105.284 64.2459) rotate(61.35) scale(10.54)"
        gradientUnits="userSpaceOnUse"
        id="paint33_radial_792_417"
        r="1"
      >
        <stop stopColor="#1A2819" />
        <stop offset="0.3" stopColor="#162316" stopOpacity="0.7569" />
        <stop offset="0.67" stopColor="#0D150D" stopOpacity="0.25" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(110.563 74.3889) rotate(-118.65) scale(3.612 15.05)"
        gradientUnits="userSpaceOnUse"
        id="paint34_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(110.563 74.3889) rotate(-118.65) scale(1.1184 4.66)"
        gradientUnits="userSpaceOnUse"
        id="paint35_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(110.563 74.3889) rotate(-118.65) scale(1.524 6.35)"
        gradientUnits="userSpaceOnUse"
        id="paint36_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-3.16929 -42.5791) rotate(44.83) scale(0.6176 21.8476)"
        gradientUnits="userSpaceOnUse"
        id="paint37_radial_792_417"
        r="1"
      >
        <stop stopColor="#394C41" />
        <stop offset="0.21" stopColor="#2F3F34" stopOpacity="0.81" />
        <stop offset="0.57" stopColor="#192218" stopOpacity="0.69" />
        <stop offset="0.83" stopColor="#0B110C" stopOpacity="0.1024" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(104.191 65.6241) rotate(-28.65) scale(3.612 15.05)"
        gradientUnits="userSpaceOnUse"
        id="paint38_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(104.191 65.6241) rotate(-28.65) scale(1.1184 4.66)"
        gradientUnits="userSpaceOnUse"
        id="paint39_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(104.191 65.6241) rotate(-28.65) scale(1.524 6.35)"
        gradientUnits="userSpaceOnUse"
        id="paint40_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-48.2113 217.683) rotate(134.83) scale(0.6176 21.8476)"
        gradientUnits="userSpaceOnUse"
        id="paint41_radial_792_417"
        r="1"
      >
        <stop stopColor="#394C41" />
        <stop offset="0.21" stopColor="#2F3F34" stopOpacity="0.81" />
        <stop offset="0.57" stopColor="#192218" stopOpacity="0.69" />
        <stop offset="0.83" stopColor="#0B110C" stopOpacity="0.1024" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(104.575 64.7083) rotate(61.35) scale(3.23)"
        gradientUnits="userSpaceOnUse"
        id="paint42_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(104.564 64.7064) rotate(61.35) scale(5.87)"
        gradientUnits="userSpaceOnUse"
        id="paint43_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(33.6686 94.5028) rotate(61.35) scale(16.07)"
        gradientUnits="userSpaceOnUse"
        id="paint44_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(33.6775 94.5188) rotate(61.35) scale(10.54)"
        gradientUnits="userSpaceOnUse"
        id="paint45_radial_792_417"
        r="1"
      >
        <stop stopColor="#1A2819" />
        <stop offset="0.3" stopColor="#162316" stopOpacity="0.7569" />
        <stop offset="0.67" stopColor="#0D150D" stopOpacity="0.25" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(38.9741 104.706) rotate(-118.65) scale(3.612 15.05)"
        gradientUnits="userSpaceOnUse"
        id="paint46_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(38.9741 104.706) rotate(-118.65) scale(1.1184 4.66)"
        gradientUnits="userSpaceOnUse"
        id="paint47_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(38.9741 104.706) rotate(-118.65) scale(1.524 6.35)"
        gradientUnits="userSpaceOnUse"
        id="paint48_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-60.3886 2.05604) rotate(44.83) scale(0.6176 21.8476)"
        gradientUnits="userSpaceOnUse"
        id="paint49_radial_792_417"
        r="1"
      >
        <stop stopColor="#394C41" />
        <stop offset="0.21" stopColor="#2F3F34" stopOpacity="0.81" />
        <stop offset="0.57" stopColor="#192218" stopOpacity="0.69" />
        <stop offset="0.83" stopColor="#0B110C" stopOpacity="0.1024" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(33.0119 95.6589) rotate(-28.65) scale(3.612 15.05)"
        gradientUnits="userSpaceOnUse"
        id="paint50_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(33.0119 95.6589) rotate(-28.65) scale(1.1184 4.66)"
        gradientUnits="userSpaceOnUse"
        id="paint51_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(33.0119 95.6589) rotate(-28.65) scale(1.524 6.35)"
        gradientUnits="userSpaceOnUse"
        id="paint52_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-128.544 256.706) rotate(134.83) scale(0.6176 21.8476)"
        gradientUnits="userSpaceOnUse"
        id="paint53_radial_792_417"
        r="1"
      >
        <stop stopColor="#394C41" />
        <stop offset="0.21" stopColor="#2F3F34" stopOpacity="0.81" />
        <stop offset="0.57" stopColor="#192218" stopOpacity="0.69" />
        <stop offset="0.83" stopColor="#0B110C" stopOpacity="0.1024" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(32.9523 94.9853) rotate(61.35) scale(3.23 3.23)"
        gradientUnits="userSpaceOnUse"
        id="paint54_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(32.9475 94.9752) rotate(61.35) scale(5.87)"
        gradientUnits="userSpaceOnUse"
        id="paint55_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.6774 112.858) rotate(61.35) scale(5.96)"
        gradientUnits="userSpaceOnUse"
        id="paint56_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.6927 112.875) rotate(61.35) scale(3.91)"
        gradientUnits="userSpaceOnUse"
        id="paint57_radial_792_417"
        r="1"
      >
        <stop stopColor="#1A2819" />
        <stop offset="0.3" stopColor="#162316" stopOpacity="0.7569" />
        <stop offset="0.67" stopColor="#0D150D" stopOpacity="0.25" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(79.0105 122.84) rotate(-118.65) scale(1.3392 5.58)"
        gradientUnits="userSpaceOnUse"
        id="paint58_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(79.0106 122.84) rotate(-118.65) scale(0.415201 1.73)"
        gradientUnits="userSpaceOnUse"
        id="paint59_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(79.0105 122.84) rotate(-118.65) scale(0.566399 2.36)"
        gradientUnits="userSpaceOnUse"
        id="paint60_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-21.7657 18.184) rotate(44.83) scale(0.2288 8.0938)"
        gradientUnits="userSpaceOnUse"
        id="paint61_radial_792_417"
        r="1"
      >
        <stop stopColor="#394C41" />
        <stop offset="0.21" stopColor="#2F3F34" stopOpacity="0.81" />
        <stop offset="0.57" stopColor="#192218" stopOpacity="0.69" />
        <stop offset="0.83" stopColor="#0B110C" stopOpacity="0.1024" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.2035 113.39) rotate(-28.65) scale(1.3392 5.58)"
        gradientUnits="userSpaceOnUse"
        id="paint62_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.2035 113.39) rotate(-28.65) scale(0.4152 1.73)"
        gradientUnits="userSpaceOnUse"
        id="paint63_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.2034 113.39) rotate(-28.65) scale(0.5664 2.36)"
        gradientUnits="userSpaceOnUse"
        id="paint64_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-78.5487 265.382) rotate(134.83) scale(0.2288 8.0938)"
        gradientUnits="userSpaceOnUse"
        id="paint65_radial_792_417"
        r="1"
      >
        <stop stopColor="#394C41" />
        <stop offset="0.21" stopColor="#2F3F34" stopOpacity="0.81" />
        <stop offset="0.57" stopColor="#192218" stopOpacity="0.69" />
        <stop offset="0.83" stopColor="#0B110C" stopOpacity="0.1024" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.411 113.037) rotate(61.35) scale(1.2)"
        gradientUnits="userSpaceOnUse"
        id="paint66_radial_792_417"
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="0.1" stopColor="#F9F9F9" stopOpacity="0.9604" />
        <stop offset="0.23" stopColor="#EAEBEB" stopOpacity="0.8464" />
        <stop offset="0.36" stopColor="#D2D2D2" stopOpacity="0.6889" />
        <stop offset="0.5" stopColor="#B0B0B0" stopOpacity="0.4761" />
        <stop offset="0.65" stopColor="#838484" stopOpacity="0.2704" />
        <stop offset="0.81" stopColor="#4D4F4F" stopOpacity="0.09" />
        <stop offset="0.96" stopColor="#0F1111" stopOpacity="0.01" />
        <stop offset="1" stopColor="#000202" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(73.411 113.037) rotate(61.35) scale(2.18 2.18)"
        gradientUnits="userSpaceOnUse"
        id="paint67_radial_792_417"
        r="1"
      >
        <stop />
        <stop offset="0.88" stopColor="#0E1A1D" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_792_417">
        <rect fill="white" height="150.62" width="166.19" />
      </clipPath>
    </defs>
  </svg>
);

export default Badge4;
